module.exports = __webpack_public_path__ + "static/media/model-03.26d0e864.jpg";